import { forwardRef, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';

import { ModalService } from '../../../../services/modal.service';
import { OrganizationService } from '../../../../services/organization/organization.service';
import { PaymentMethodsService } from '../../../../services/financial-accounts/payment-methods.service';
import { StripeService } from '../../../../services/billing/stripe.service';
import { MicrodepositVerificationModule } from '../bank-account-manager/microdeposit-verification/microdeposit-verification.module';
import { CreditCardCollectorModule } from '../credit-card-collector/credit-card-collector.module';
import { LegfiCurrencyPipeModule } from '../../../../pipes/format/legfi-currency.module';
import { ModalModule } from '../../../shared/modal/modal.module';
import { PaymentMethodSelectorComponent } from './payment-method-selector.component';
import { BankAccountManagerModule } from '../bank-account-manager/bank-account-manager.module';
import { PlaidService } from '../../../../services/plaid.service';

export const PAYMENT_METHOD_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => PaymentMethodSelectorComponent),
    multi: true,
};

@NgModule({
    imports: [
        // Shared
        SharedModule,
        // Dependencies
        MicrodepositVerificationModule,
        BankAccountManagerModule,
        CreditCardCollectorModule,
        ModalModule,
        LegfiCurrencyPipeModule,
    ],
    declarations: [PaymentMethodSelectorComponent],
    exports: [
        PaymentMethodSelectorComponent,
    ],
    providers: [
        // Control Value Accessor.
        PAYMENT_METHOD_VALUE_ACCESSOR,
        // Services
        ModalService,
        OrganizationService,
        PaymentMethodsService,
        StripeService,
        PlaidService,
    ],
})
export class PaymentMethodSelectorModule
{
}
